import styled from 'styled-components'

export const ScrollableList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-height: 240px;
  overflow-y: auto;
`
